import * as actionTypes from './actionTypes'

import empAxios from '../../axios/employee'
import { saveFileFromResponse } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'

export const fetchEmployees = filterOptions => {
  return dispatch => {
    const params = {
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 15,
      company_id: filterOptions ? filterOptions.company_id : null,
      org_id: filterOptions ? filterOptions.org_id : null,
      level_id: filterOptions ? filterOptions.level_id : null,
      position_id: filterOptions ? filterOptions.position_id : null,
      emp_id: filterOptions ? filterOptions.emp_id : null
    }
    dispatch(fetchEmployeesStart())
    empAxios
      .get('', {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: +per_page,
            from,
            to,
            total
          }

          dispatch(fetchEmployeesSuccess(pagination, data))
        }
      })
      .catch(error => {
        dispatch(fetchEmployeesFailed(error))
      })
  }
}

export const fetchEmployeesStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_START
  }
}

export const fetchEmployeesSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_SUCCESS,
    pagination,
    records
  }
}

export const fetchEmployeesFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_FAILED,
    errorMessage
  }
}

export const fetchEmployeeById = recordId => {
  return dispatch => {
    dispatch(fetchEmployeesStart())
    empAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmployeeByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmployeesFailed(error))
      })
  }
}

export const fetchEmployeeByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedEmployeeRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_EMPLOYEE_RECORD
  }
}

export const createEmployee = (recordData, page) => {
  return dispatch => {
    dispatch(createEmployeeStart())

    empAxios
      .post('', recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Employee Created',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(createEmployeeSuccess())
        dispatch(fetchEmployees(page))
        dispatch(clearSelectedEmployeeRecord())
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Employee field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createEmployeeFailed())
      })
  }
}

export const createEmployeeStart = () => {
  return {
    type: actionTypes.CREATE_EMPLOYEE_START
  }
}

export const createEmployeeSuccess = () => {
  return {
    type: actionTypes.CREATE_EMPLOYEE_SUCCESS
  }
}

export const createEmployeeFailed = () => {
  return {
    type: actionTypes.CREATE_EMPLOYEE_FAILED
  }
}

export const updateEmployee = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateEmployeeStart())
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }
    empAxios
      .post(`/${recordId}`, recordData, config)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Employee Updated',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(updateEmployeeSuccess())
        dispatch(fetchEmployees(page))
        dispatch(clearSelectedEmployeeRecord())
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Employee field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateEmployeeFailed())
      })
  }
}

export const updateEmployeeStart = () => {
  return {
    type: actionTypes.UPDATE_EMPLOYEE_START
  }
}

export const updateEmployeeSuccess = () => {
  return {
    type: actionTypes.UPDATE_EMPLOYEE_SUCCESS
  }
}

export const updateEmployeeFailed = () => {
  return {
    type: actionTypes.UPDATE_EMPLOYEE_FAILED
  }
}

export const deleteEmployees = (recordIds, page) => {
  return dispatch => {
    const params = {
      emp_id: recordIds
    }

    dispatch(deleteEmployeesStart())
    empAxios
      .delete('', {
        params
      })
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Employee Deleted',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(deleteEmployeesSuccess())
        dispatch(fetchEmployees(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteEmployeesFailed())
      })
  }
}

export const deleteEmployeesStart = () => {
  return {
    type: actionTypes.DELETE_EMPLOYEE_START
  }
}

export const deleteEmployeesSuccess = message => {
  return {
    type: actionTypes.DELETE_EMPLOYEE_SUCCESS,
    message
  }
}

export const deleteEmployeesFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_EMPLOYEE_FAILED,
    errorMessage
  }
}

export const importEmployee = importFile => {
  return dispatch => {
    dispatch(importEmployeeStart())
    let formData = new FormData()
    formData.append('file', importFile)

    empAxios
      .post('/import', formData)
      .then(response => {
        if (response.status === 200) {
          dispatch(importEmployeeSuccess(response.data))
          dispatch(fetchEmployees())
          dispatch(
            enqueueSnackbar({
              message: 'Employee Imported',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Employee Imported Error',
            options: {
              variant: 'error',
              data: error.response.data.data
            }
          })
        )
        dispatch(importEmployeeFailed(error))
      })
  }
}

export const importEmployeeStart = () => {
  return {
    type: actionTypes.IMPORT_EMPLOYEE_START
  }
}

export const importEmployeeSuccess = () => {
  return {
    type: actionTypes.IMPORT_EMPLOYEE_SUCCESS
  }
}

export const importEmployeeFailed = errorMessage => {
  return {
    type: actionTypes.IMPORT_EMPLOYEE_FAILED,
    errorMessage
  }
}

export const exportEmployee = filterOptions => {
  return dispatch => {
    dispatch(exportEmployeeStart())
    let params = null
    if (filterOptions) {
      const { company_id, org_id, level_id, position_id, emp_id } = filterOptions
      params = {
        company_id,
        org_id,
        level_id,
        position_id,
        emp_id
      }
    }
    empAxios
      .get('/export', {
        params,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Employee Exported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(exportEmployeeSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Employee field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(exportEmployeeFailed(error))
      })
  }
}

export const exportEmployeeStart = () => {
  return {
    type: actionTypes.EXPORT_EMPLOYEE_START
  }
}

export const exportEmployeeSuccess = () => {
  return {
    type: actionTypes.EXPORT_EMPLOYEE_SUCCESS
  }
}

export const exportEmployeeFailed = errorMessage => {
  return {
    type: actionTypes.EXPORT_EMPLOYEE_FAILED,
    errorMessage
  }
}

export const downloadEmployeeTemplate = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(downloadEmployeeTemplateStart())
    empAxios
      .get('/download', {
        responseType: 'blob',
        params
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Employee Template Downloaded',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(downloadEmployeeTemplateSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Employee field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(downloadEmployeeTemplateFailed(error))
      })
  }
}

export const downloadEmployeeTemplateStart = () => {
  return {
    type: actionTypes.DOWNLOAD_EMPLOYEE_TEMPLATE_START
  }
}

export const downloadEmployeeTemplateSuccess = () => {
  return {
    type: actionTypes.DOWNLOAD_EMPLOYEE_TEMPLATE_SUCCESS
  }
}

export const downloadEmployeeTemplateFailed = errorMessage => {
  return {
    type: actionTypes.DOWNLOAD_EMPLOYEE_TEMPLATE_FAILED,
    errorMessage
  }
}

export const fetchOrganizationOptionsForEmployee = filterOptions => {
  let params = {}
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchOrganizationOptionsForEmployeeStart())
    empAxios
      .get('org/dropdown', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrganizationOptionsForEmployeeSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrganizationOptionsForEmployeeFailed(error))
      })
  }
}

export const fetchOrganizationOptionsForEmployeeStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_START
  }
}

export const fetchOrganizationOptionsForEmployeeSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_SUCCESS,
    data
  }
}

export const fetchOrganizationOptionsForEmployeeFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_FAILED,
    errorMessage
  }
}

export const fetchEmpPositions = ({ emp_id, ...filterOptions }) => {
  return async dispatch => {
    if (!emp_id) {
      throw new Error('emp_id is required for this function')
    }
    dispatch(fetchEmpPositionsStart())
    try {
      const response = await empAxios.get(`/${emp_id}/position`, { params: filterOptions })
      if (response.status === 200) {
        const data = response.data.data
        dispatch(fetchEmpPositionsSuccess(data))
      }
    } catch (error) {
      dispatch(fetchEmpPositionsFailed())
    }
  }
}

const fetchEmpPositionsStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_POSITIONS_START
  }
}

const fetchEmpPositionsSuccess = data => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_POSITIONS_SUCCESS,
    data
  }
}

const fetchEmpPositionsFailed = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_POSITIONS_FAILED
  }
}
